module.exports = __webpack_public_path__ + "img/icon-activity-news.de6e2675.svg";